<!-- 
<div *ngIf="areas">
    <form *ngIf="areas.length > 1" [formGroup]="filterForm">
        <mat-form-field appearance="outline">
            <mat-label>Filtrar materias...</mat-label>
            <mat-select formControlName="materias" multiple>
                <mat-option *ngFor="let area of areas" value="topping">Materia</mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>
 -->
<div class="rubrica-unidad-container">
    <div class="rubrica-table">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px;">
            <h3 class="mat-h2">Rúbrica de la unidad</h3>
            <button *ngIf="!isFamilia" mat-raised-button color="primary" (click)="dialogoCompartir()">Compartir en
                Classroom</button>
        </div>

        <mat-table #table [dataSource]="rubrica" *ngIf="rubrica; else loading" class="mat-elevation-z4">

            <!-- FIXME:  Calculo dinamico de las columnas-->
            <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
                <mat-header-cell *matHeaderCellDef class="mat-cell"> {{column | uppercase}} </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell">
                    <ng-container *ngIf="column === 'Meta'">
                        <div [title]="element.id">
                            {{element.txtIdioma}}
                        </div>
                    </ng-container>
                    <ng-container *ngIf="column == 'Criterio'">
                        {{element.criterioNivel}}
                    </ng-container>
                    <ng-container *ngIf="column == 'Evidencias'">
                        <ul>
                            <li *ngFor="let evento of element.eventosAprendizaje">{{evento.nombre}}</li>
                        </ul>
                    </ng-container>
                    <ng-container #default *ngIf="column !== 'Meta' && column !== 'Criterio' && column !== 'Evidencias'">
                        {{element[column]}}
                    </ng-container>
                </mat-cell>
            </ng-container>

            <!-- 
            <ng-container matSort matColumnDef="Meta">
                <mat-header-cell *matHeaderCellDef>Meta</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    <div style="padding: 0 12px" [title]="element.id">
                        <span [innerHTML]="element.txtIdioma | HTMLEntitiesCleaner"></span>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Criterio">
                <mat-header-cell *matHeaderCellDef>Criterio</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    <span [innerHTML]="element.criterioNivel | HTMLEntitiesCleaner"></span>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="MT">
                <mat-header-cell *matHeaderCellDef>FT</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    {{element.ld}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="FT">
                <mat-header-cell *matHeaderCellDef>MT</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    {{element.l}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LP">
                <mat-header-cell *matHeaderCellDef>LP</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    {{element.lp}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="NL">
                <mat-header-cell *matHeaderCellDef>NL</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    {{element.nl}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Evidencias">
                <mat-header-cell *matHeaderCellDef>Evidencias</mat-header-cell>
                <mat-cell *matCellDef="let element;">
                    <ul>
                        <li *ngFor="let evento of element.eventosAprendizaje">{{evento.nombre}}</li>
                    </ul>
                </mat-cell>
            </ng-container>
             -->

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>
        </mat-table>
        <ng-template #loading>
            <mat-spinner [mode]="'indeterminate'"></mat-spinner>
        </ng-template>
    </div>
</div>